import { Component, Input } from "@angular/core";

@Component({
  selector: "app-pill",
  templateUrl: "./pill.component.html",
  styleUrl: "./pill.component.scss",
  imports: [],
})
export class PillComponent {
  @Input() public count: number | string = 0;
  @Input() public theme: "orange" | "green" | "blue" = "orange";

  protected get buttonClasses(): string[] {
    return ["pill", `pill--${this.theme}`];
  }
}
